import React, { PureComponent, ReactElement } from 'react';
import { connect } from 'react-redux';
import SideBar from './sidebar';
import ActivitiesFilterResultPage from './page';
import { RemoteActivity, RemoteType, RemoteOrganizer } from '../types';
import { oneYear, today } from '../utils';
import { fetchActivitiesAction } from '../service/activities';
import { fetchOrganizersAction } from '../service/organizers';
import { fetchTypesAction } from '../service/types';
import ErrorMessageBoundary from '../errors/error-message-boundary';

export interface ActivitiesFilterPageProps {
  activities: RemoteActivity[];
  organizers: RemoteOrganizer[];
  types: RemoteType[];
  fetchOrganizers(): void;
  fetchActivities(filter): void;
  fetchTypes(): void;
}

class ActivitiesFilterPage extends PureComponent<ActivitiesFilterPageProps> {
  state = { kaboom: false };
  componentDidMount(): void {
    // this code is "duplicated" in date-sidebar
    // really should be made as props and passed in to date-sidebar
    this.props.fetchActivities({
      from: today(),
      to: oneYear(),
    });
    this.props.fetchOrganizers();
    this.props.fetchTypes();
  }

  render(): ReactElement {
    return (
      <ErrorMessageBoundary name="activities-filter-page" errorIsClearable>
        <div id="activities-wrapper" className="clearfix">
          <div id="sidebar-first-spacer" className="sidebar-spacer">
            <div id="sidebar-first" className="sidebar sticky">
              <aside className="sidebar-first" role="complementary">
                <SideBar {...this.props} />
              </aside>
            </div>
          </div>
          <main role="main" className="main-content main">
            <ActivitiesFilterResultPage activities={this.props.activities} organizers={this.props.organizers} />
          </main>
        </div>
      </ErrorMessageBoundary>
    );
  }
}

const mapStateToProps = ({ activities, organizers, types }) => ({
  activities,
  organizers,
  types,
});

const mapDispatchToProps = (dispatch) => ({
  fetchActivities: fetchActivitiesAction(dispatch),
  fetchOrganizers: (): void => fetchOrganizersAction(dispatch),
  fetchTypes: (): void => fetchTypesAction(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesFilterPage);
